"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replacePackagingHierarchyLevelsSchema = exports.updatePackagingHierarchyTemplateSchema = exports.createPackagingHierarchyTemplateSchema = exports.packagingHierarchyTemplateShape = exports.packagingHierarchyTemplateLevelSchema = exports.packagingHierarchyTemplateLevelShape = void 0;
const zod_1 = require("zod");
exports.packagingHierarchyTemplateLevelShape = {
    sequenceLevel: zod_1.z.number().int().positive(),
    unitId: zod_1.z.string().uuid(),
    conversionFactorFromPreviousLevel: zod_1.z.number().positive().optional(),
};
exports.packagingHierarchyTemplateLevelSchema = zod_1.z.object(exports.packagingHierarchyTemplateLevelShape);
exports.packagingHierarchyTemplateShape = {
    templateCode: zod_1.z.string().min(1).max(30).optional(),
    name: zod_1.z.string().min(1).max(255),
};
exports.createPackagingHierarchyTemplateSchema = zod_1.z.object({
    ...exports.packagingHierarchyTemplateShape,
    levels: zod_1.z.array(exports.packagingHierarchyTemplateLevelSchema).default([]),
});
exports.updatePackagingHierarchyTemplateSchema = zod_1.z.object(exports.packagingHierarchyTemplateShape).partial();
exports.replacePackagingHierarchyLevelsSchema = zod_1.z.object({ levels: zod_1.z.array(exports.packagingHierarchyTemplateLevelSchema) });
//# sourceMappingURL=packaging-hierarchy-template.schema.js.map